module.exports = __webpack_public_path__ + "img/disrole.2fc7bff6.svg";